import React from 'react';
import { Container } from '@material-ui/core';
import { withRouter } from 'react-router';
import RegistrationRequestForm from './components/request_form';

interface IProps {}
const RegistrationRequest: React.FC<IProps> = (props) => {
  // console.log('Render RegistrationRequest');
  return (
    <Container style={{ paddingTop: '2rem' }}>
      <RegistrationRequestForm />
    </Container>
  );
};

export default withRouter(RegistrationRequest);
